module.exports = __webpack_public_path__ + "static/img/start-0.626c7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/start-0.jpg
// module id = J3XJ
// module chunks = 0